// ADDRESS QUESTION TYPE
export const addressSkinIds = {
  DEFAULT: 'default',
  GOOGLE_AUTOCOMPLETE: 'googleAutocomplete'
}

export const addressAutocompleteModeIds = {
  MANUAL: 'manual',
  SEARCH: 'search'
}

export const addressAutocompleteModes = [
  {
    id: addressAutocompleteModeIds.MANUAL,
    label: 'Manual'
  },
  {
    id: addressAutocompleteModeIds.SEARCH,
    label: 'Search'
  }
]

export const addressSkins = [
  {
    id: addressSkinIds.DEFAULT,
    label: 'Default'
  },
  {
    id: addressSkinIds.GOOGLE_AUTOCOMPLETE,
    label: 'Google Autocomplete'
  }
]

// Date Quetion type skins
export const dateSkinIds = {
  THREE_INPUT_BOXES: 'threeInputBoxes',
  ONE_INPUT_BOX: 'oneInputBox',
  DROPDOWN: 'dropdown',
  DATE_PICKER: 'datePicker'
}
export const dateSkins = [
  {
    id: dateSkinIds.THREE_INPUT_BOXES,
    label: '3 Input Boxes'
  },
  {
    id: dateSkinIds.ONE_INPUT_BOX,
    label: '1 Input Box'
  },
  {
    id: dateSkinIds.DROPDOWN,
    label: 'Dropdown'
  },
  {
    id: dateSkinIds.DATE_PICKER,
    label: 'Date Picker'
  }
]

// Range Quetion type skins
export const rangeSkinIds = {
  SLIDER_SCALE: 'sliderscale',
  RANGE_SCALE: 'rangescale',
  LIKERT_SCALE: 'likertscale',
  LIKERT_SMILEYS_SCALE: 'likertsmileysscale',
  NUMBER_SCALE: 'numberscale'
}
export const rangeSkins = [
  {
    id: rangeSkinIds.SLIDER_SCALE,
    label: 'Slider Scale'
  },
  {
    id: rangeSkinIds.RANGE_SCALE,
    label: 'Range Scale'
  },
  {
    id: rangeSkinIds.LIKERT_SCALE,
    label: 'Likert Scale'
  },
  {
    id: rangeSkinIds.LIKERT_SMILEYS_SCALE,
    label: 'Likert Scale - Smileys'
  }
]
// NPS only uses Number Scale - kept out of rangeSkins so it never shows on the Scale (RANGE) type
export const npsSkins = [
  {
    id: rangeSkinIds.NUMBER_SCALE,
    label: 'Number Scale'
  }
]
// NPS is always scored on a fixed 0-10 scale (promoters 9-10, detractors 0-6)
export const npsScale = {
  MIN: 0,
  MAX: 10
}
export const npsLabelMaxLength = 100
export const otherChoice = {
  OTHER: 'other'
}
// Yes/No Quetion type skins
export const yesNoSkinIds = {
  DEFAULT: 'default',
  INSET: 'inset'
}
export const yesNoSkins = [
  {
    id: yesNoSkinIds.DEFAULT,
    label: 'Default'
  },
  {
    id: yesNoSkinIds.INSET,
    label: 'Inset'
  }
]

// Signature Question type skins
export const signatureSkinIds = {
  DRAW: 'draw',
  TYPE: 'type',
  UPLOAD: 'upload',
  ALL: 'all'
}

export const signatureSkins = [
  {
    id: signatureSkinIds.DRAW,
    label: 'Draw'
  },
  {
    id: signatureSkinIds.TYPE,
    label: 'Type'
  },
  {
    id: signatureSkinIds.UPLOAD,
    label: 'Upload'
  },
  {
    id: signatureSkinIds.ALL,
    label: 'All - (let the signer decide)'
  }
]

// PAYMENT QUESTION TYPE
// Ids match PAYMENT_MODE_KEYS in shared/constants/payment.js - the same values the pre-skin
// `payment.mode` used, so old questions map across without translation.
export const paymentSkinIds = {
  FIXED: 'fixed',
  PRODUCTS: 'products'
}

export const paymentSkins = [
  {
    id: paymentSkinIds.FIXED,
    label: 'Fixed amount'
  },
  {
    id: paymentSkinIds.PRODUCTS,
    label: 'Sell products'
  }
]
